import React, { useEffect, useState } from "react";
import "../AccountInformation/AccountInformation.css";
import { BiSolidPencil, BiDetail, BiWorld } from "react-icons/bi";
import { FaUser } from "react-icons/fa6";
import { TbAffiliate } from "react-icons/tb";
import {
  APIUrl,
  APIUrlToken,
  getIsUser,
  SetlocalStorage,
} from "../../../Utils/Utils";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../../Components/Loader/Loader";
import { IoSchoolOutline } from "react-icons/io5";
import LocationSearch from "./LocationSearch";
import { ImCross } from "react-icons/im";
import { IoMdHome } from "react-icons/io";
import { FaCity } from "react-icons/fa";
import { FaLocationPin } from "react-icons/fa6";
import { FaBuilding } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";

const AthleteUserRole = () => {
  const userLoginDetails = getIsUser();
  const adminStatus = localStorage.getItem("user_role");
  const [isError, setIsError] = useState(false);

  const [disableEdit, setDisableEdit] = useState("");
  const [disableEditNormal, setDisableEditNormal] = useState("");

  const [loading, setLoading] = useState(false);
  const [imagesChanged, setImagesChanged] = useState(false);
  const [originalFormData, setOriginalFormData] = useState(null);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    accolades: "",
    affiliations: "",
    athlete_profile_id: "",
    background: "",
    facebook_url: "",
    hometown: "",
    images_base64: [],
    instagram_url: "",
    interests: [],
    location: "",
    tiktok_url: "",
    twitter_url: "",
    youtube_url: "",
    high_school: "",
    preferred_locations: [],
    previous_school: "",
    summary: "",
  });
  const [formDataEdit, setFormDataEdit] = useState({
    firstname: "",
    lastname: "",
    phoneno: "",
    address: "",
    city: "",
    state: "",
    country: "",
    company_name: "",
    zipcode: "",
  });

  const handleEditClick = () => setDisableEdit("edit");
  const handleEditClickNormal = () => setDisableEditNormal("edit");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Image upload handler (max 10 images)
  const handleImageChange = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    const totalFiles = [...formData.images_base64, ...files].slice(0, 10);

    const base64Images = await Promise.all(
      totalFiles.map((file) => {
        if (typeof file === "string") return file;
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result.split(",")[1]);
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      })
    );

    setFormData((prev) => ({
      ...prev,
      images_base64: base64Images,
    }));

    setImagesChanged(true);
    e.target.value = null;
  };

  const handleDeleteImage = (index) => {
    setFormData((prev) => {
      const updatedImages = prev.images_base64.filter((_, i) => i !== index);
      return { ...prev, images_base64: updatedImages };
    });
    setImagesChanged(true);
  };
  const interestCategories = [
    {
      title: "Entertainment & Pop Culture",
      options: [
        "Movies",
        "TV Shows",
        "Music",
        "Podcasts",
        "Video Games",
        "Anime / Manga",
        "Comics / Graphic Novels",
        "Collectibles",
        "Board Games",
        "Esports",
      ],
    },
    {
      title: "Physical Activities",
      options: [
        "Yoga",
        "Pilates",
        "Gym / Weightlifting",
        "CrossFit",
        "Running / Jogging",
        "Cycling",
        "Hiking",
        "Surfing",
        "Skateboarding",
        "Dance",
        "Cheerleading",
        "Skiing / Snowboarding",
        "Fishing",
        "Hunting",
      ],
    },
    {
      title: "Creative & Artistic",
      options: [
        "Drawing",
        "Painting",
        "Photography",
        "Videography",
        "Graphic Design",
        "Fashion Design",
        "DIY / Crafts",
        "Writing",
        "Poetry",
        "Acting / Theater",
        "Music Production",
        "Singing",
        "Playing Instruments",
        "Makeup Artistry",
      ],
    },
    {
      title: "Travel & Culture",
      options: [
        "Traveling",
        "Road Trips",
        "Camping",
        "Food Exploration / Foodie",
        "Learning Languages",
        "Cultural Experiences",
        "Museums / Art Galleries",
      ],
    },
    {
      title: "Learning & Personal Growth",
      options: [
        "Reading",
        "Studying",
        "Technology",
        "Science",
        "History",
        "Finance / Investing",
        "Business / Entrepreneurship",
        "Personal Development",
        "Podcasts (Educational)",
      ],
    },
    {
      title: "Tech & Digital Life",
      options: [
        "Coding",
        "Web Design",
        "App Development",
        "AI / Machine Learning",
        "Crypto / Blockchain",
        "Tech Gadgets",
        "Smart Home",
        "Digital Art / NFTs",
      ],
    },
    {
      title: "Home & Lifestyle",
      options: [
        "Cooking",
        "Baking",
        "Gardening",
        "Home Improvement",
        "Interior Design",
        "Fitness & Wellness",
        "Meditation",
        "Animals / Pets",
        "Volunteering",
      ],
    },
    {
      title: "Outdoor & Adventure",
      options: [
        "Boating",
        "Sailing",
        "Scuba Diving",
        "Snorkeling",
        "Rock Climbing",
        "ATV / Off-roading",
        "Stargazing",
        "Nature Photography",
      ],
    },
    {
      title: "Professional & Career Interests",
      options: [
        "Marketing",
        "Social Media",
        "Leadership",
        "Networking",
        "Real Estate",
        "Coaching / Mentorship",
        "Event Planning",
      ],
    },
  ];
  const handleInterestCheckbox = (value) => {
    setFormData((prev) => {
      const updated = prev.interests.includes(value)
        ? prev.interests.filter((item) => item !== value)
        : [...prev.interests, value];

      return { ...prev, interests: updated };
    });
  };

  const getProfileInfo = () => {
    const url = `${APIUrl()}/v1/athlete_profile/${userLoginDetails?.user_id}`;
    axios
      .get(url, {
        headers: {
          "X-API-Key": APIUrlToken(),
        },
      })
      .then((response) => {
        const data = response?.data;
        const fetchedData = {
          accolades: data?.accolades || "",
          affiliations: data?.affiliations || "",
          athlete_profile_id: data?.athlete_profile_id || "",
          background: data?.background || "",
          facebook_url: data?.facebook_url || "",
          hometown: data?.hometown || "",
          images_base64: data?.images_base64 || data?.images || [],
          instagram_url: data?.instagram_url || "",
          interests: data?.interests || [],
          preferred_locations: data?.preferred_locations || [],
          location: data?.location || "",
          tiktok_url: data?.tiktok_url || "",
          twitter_url: data?.twitter_url || "",
          youtube_url: data?.youtube_url || "",
          high_school: data?.high_school || "",
          previous_school: data?.previous_school || "",
          summary: data?.summary || "",
        };
        setFormData(fetchedData);
        setOriginalFormData(fetchedData);
        setIsError(false);
        setImagesChanged(false);
      })
      .catch((error) => {
        if (error?.response?.data?.detail === "User profile not found.") {
          setIsError(true);
        }
        console.error("Error fetching athlete profile:", error);
      });
  };

  useEffect(() => {
    getProfileInfo();
  }, []);

  const addUserProfileDetails = () => {
    setLoading(true);
    const url = `${APIUrl()}/v1/athlete_profile`;

    const data = {
      user_id: userLoginDetails?.user_id,
      accolades: formData.accolades,
      affiliations: formData.affiliations,
      background: formData.background,
      facebook_url: formData.facebook_url,
      hometown: formData.hometown,
      instagram_url: formData.instagram_url,
      interests: formData.interests,
      preferred_locations: formData?.preferred_locations,
      location: formData.location,
      tiktok_url: formData.tiktok_url,
      twitter_url: formData.twitter_url,
      youtube_url: formData.youtube_url,
      high_school: formData.high_school,
      previous_school: formData.previous_school,
      summary: formData.summary,
      images_base64: formData.images_base64,
    };

    axios
      .post(url, data, {
        headers: {
          "X-API-Key": APIUrlToken(),
        },
      })
      .then(() => {
        setLoading(false);
        getProfileInfo();
        setDisableEdit("");
        setImagesChanged(false);
        toast.success("Athlete Profile added successfully.");
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error adding athlete profile:", error);
        toast.error("Failed to add athlete profile.");
      });
  };

  const updateUserProfileDetails = () => {
    setLoading(true);
    const replaceImagesFlag = !!imagesChanged;
    const url = `${APIUrl()}/v1/athlete_profile/${
      userLoginDetails?.user_id
    }?replace_images=${replaceImagesFlag}`;

    const data = {
      affiliations: formData.affiliations,
      accolades: formData.accolades,
      location: formData.location,
      background: formData.background,
      hometown: formData.hometown,
      interests: formData.interests.length ? formData.interests : [""],
      // preferred_locations: formData?.preferred_locations?.length
      //   ? formData?.preferred_locations
      //   : [""],
      preferred_locations:
        formData.preferred_locations.length > 0
          ? formData.preferred_locations
          : [],

      instagram_url: formData.instagram_url,
      twitter_url: formData.twitter_url,
      tiktok_url: formData.tiktok_url,
      facebook_url: formData.facebook_url,
      youtube_url: formData.youtube_url,
      high_school: formData.high_school,
      previous_school: formData.previous_school,
      summary: formData.summary,
      updated_at: new Date().toISOString(),
    };

    if (replaceImagesFlag) {
      data.images_base64 = formData.images_base64;
    }

    axios
      .patch(url, data, {
        headers: {
          "X-API-Key": APIUrlToken(),
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then(() => {
        setLoading(false);
        getProfileInfo();
        setDisableEdit("");
        setImagesChanged(false);
        toast.success("Athlete Profile updated successfully.");
      })
      .catch((error) => {
        setLoading(false);
        console.error(
          "Error updating athlete profile:",
          error?.response?.data || error
        );
        toast.error("Failed to update athlete profile.");
      });
  };

  const handleCancel = () => {
    if (originalFormData) {
      setFormData(originalFormData);
      setImagesChanged(false);
    }
    setDisableEdit("");
  };
  const handleChangeEdit = (e) => {
    setFormDataEdit({
      ...formDataEdit,
      [e.target.name]: e.target.value,
    });
  };

  const updateUserProfileDetailsUser = () => {
    setLoading(true);
    const url = `${APIUrl()}/v1/user-profiles/${userLoginDetails?.user_id}`;

    let data = {};
    if (formDataEdit?.firstname) {
      data.first_name = formDataEdit.firstname;
    }
    if (formDataEdit?.lastname) {
      data.last_name = formDataEdit.lastname;
    }
    if (formDataEdit?.phoneno) {
      data.phone_number = formDataEdit.phoneno;
    }
    if (formDataEdit?.address) {
      data.address = formDataEdit.address;
    }
    if (formDataEdit?.city) {
      data.city = formDataEdit.city;
    }
    if (formDataEdit?.state) {
      data.state = formDataEdit.state;
    }
    if (formDataEdit?.country) {
      data.country = formDataEdit.country;
    }
    if (formDataEdit?.company_name) {
      data.company_name = formDataEdit.company_name;
    }
    if (formDataEdit?.zipcode) {
      data.zipcode = formDataEdit.zipcode;
    }

    axios
      .put(url, data, {
        headers: {
          "X-API-Key": APIUrlToken(),
        },
      })
      .then((response) => {
        setLoading(false);
        getProfileInfo();
        setDisableEdit("");
        setFormData({
          firstname: "",
          lastname: "",
          phoneno: "",
          address: "",
          city: "",
          state: "",
          country: "",
          company_name: "",
          zipcode: "",
        });
        toast.success("User Profile updated successfully.");
        const localData = {
          ...userLoginDetails,
          given_name: formDataEdit?.firstname,
        };
        SetlocalStorage("nilUser", localData);

        navigate("/");
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching teams data:", error);
      });
  };

  const getProfileInfoEdit = () => {
    const url = `${APIUrl()}/v1/user-profiles/${userLoginDetails?.user_id}`;
    const option = {
      method: "GET",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      url: url,
    };

    axios(option)
      .then((response) => {
        let data = response?.data;
        setFormDataEdit({
          firstname: data?.first_name,
          lastname: data?.last_name,
          phoneno: data?.phone_number,
          address: data?.address,
          city: data?.city,
          state: data?.state,
          country: data?.country,
          company_name: data?.company_name,
          zipcode: data?.zipcode,
        });
        setIsError(false);
      })
      .catch((error) => {
        if (error?.response?.data?.detail === "User profile not found.") {
          setIsError(true);
        }
        console.error("Error fetching teams data:", error);
      });
  };
  useEffect(() => {
    getProfileInfoEdit();
  }, []);

  return (
    <div>
      {loading ? <Loader /> : null}
      <div className="athlete-inner-head-editdash">
        {adminStatus === "athlete" && (
          <button
            className="edit-button-accountInfo"
            onClick={() => navigate("/AthleteDashboard")}
          >
            <FaUser /> Athlete Dashboard
          </button>
        )}

        {/* {isError ? null : ( */}
        <button
          className={
            disableEdit
              ? "edit-button-accountInfo-active"
              : "edit-button-accountInfo"
          }
          onClick={handleEditClick}
        >
          <BiSolidPencil /> Edit Athlete Profile
          {/* {formData?.athlete_profile_id ? "Edit Profile" : "Edit Profile"} */}
        </button>
        {/* )}   */}

        {!adminStatus === "athlete" ? (
          ""
        ) : (
          <button
            className={
              disableEditNormal
                ? "edit-button-accountInfo-active"
                : "edit-button-accountInfo"
            }
            type="reset"
            onClick={handleEditClickNormal}
          >
            <BiSolidPencil /> Edit User Profile
          </button>
        )}
      </div>

      {
        // isError && disableEdit === "" ? (
        //   <div className="ai_no_profile">
        //     <button
        //       className="edit-button-accountInfo"
        //       onClick={() => setDisableEdit("add")}
        //     >
        //       Please create your profile
        //     </button>
        //   </div>
        // ) :
        disableEditNormal === "edit" ? (
          <></>
        ) : (
          <>
            <div className="section-title-accountInfo">Athlete Details</div>
            <div className="first-section-my-profile-athlete">
              {/* <InputField
              icon={<BiDetail />}
              name="hometown"
              placeholder="Hometown"
              value={formData.hometown}
              onChange={handleChange}
              disabled={disableEdit === ""}
            /> */}
              <LocationSearch
                value={formData.hometown}
                disabled={disableEdit === ""}
                onSelect={(loc) =>
                  setFormData((prev) => ({ ...prev, hometown: loc }))
                }
                placeholder={"Birthplace"}
              />
              <InputField
                icon={<IoSchoolOutline />}
                name="high_school"
                placeholder="High School"
                value={formData.high_school}
                onChange={handleChange}
                disabled={disableEdit === ""}
              />
              <InputField
                icon={<IoSchoolOutline />}
                name="previous_school"
                placeholder="Previous School"
                value={formData.previous_school}
                onChange={handleChange}
                disabled={disableEdit === ""}
              />
              <InputField
                icon={<BiDetail />}
                name="summary"
                placeholder="Summary (Bio) – include hometown, interests, major, etc."
                value={formData.summary}
                onChange={handleChange}
                disabled={disableEdit === ""}
              />
              <InputField
                icon={<TbAffiliate />}
                name="accolades"
                placeholder="Accolades & Awards"
                value={formData.accolades}
                onChange={handleChange}
                disabled={disableEdit === ""}
              />
              {/* <InputField
              icon={<FaLocationDot />}
              name="location"
              placeholder="Preferred Locations"
              value={formData.location}
              onChange={handleChange}
              disabled={disableEdit === ""}
            /> */}
              {/* <LocationSearch
              formData={formData}
              value={formData.location}
              disabled={disableEdit === ""}
              onSelect={(loc) =>
                setFormData((prev) => ({ ...prev, location: loc }))
              }
            /> */}
              <div className="location-input-wrapper">
                <LocationSearch
                  // pass only the first preferred location as the default value
                  value={formData.preferred_locations?.[0] ?? ""}
                  disabled={disableEdit === ""}
                  onSelect={(loc) =>
                    setFormData((prev) => {
                      const updated = Array.isArray(prev.preferred_locations)
                        ? [...prev.preferred_locations]
                        : [""];
                      updated[0] = loc;
                      return { ...prev, preferred_locations: updated };
                    })
                  }
                  placeholder={"Preferred Location"}
                />

                {disableEdit !== "" && (
                  <button
                    type="button"
                    className="add-location-inside-btn"
                    onClick={() =>
                      setFormData((prev) => {
                        const updated = Array.isArray(prev.preferred_locations)
                          ? [...prev.preferred_locations]
                          : [""];
                        // append a new empty entry for additional preferred locations
                        updated.push("");
                        return { ...prev, preferred_locations: updated };
                      })
                    }
                  >
                    + Add
                  </button>
                )}
              </div>

              {/* Render additional preferred locations (skip index 0 - the default) */}
              {formData.preferred_locations &&
                formData.preferred_locations.length > 1 &&
                formData.preferred_locations.slice(1).map((loc, idx) => {
                  const realIndex = idx + 1; // since we sliced off the first
                  return (
                    <div
                      key={realIndex}
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginBottom: "10px",
                        position: "relative",
                      }}
                    >
                      <LocationSearch
                        value={loc}
                        disabled={disableEdit === ""}
                        onSelect={(selectedLoc) =>
                          setFormData((prev) => {
                            const updated = [
                              ...(prev.preferred_locations || [""]),
                            ];
                            updated[realIndex] = selectedLoc;
                            return { ...prev, preferred_locations: updated };
                          })
                        }
                        placeholder={`Preferred Location ${realIndex + 1}`}
                      />

                      {disableEdit !== "" && (
                        <div
                          type="button"
                          onClick={() =>
                            setFormData((prev) => {
                              const updated = [
                                ...(prev.preferred_locations || [""]),
                              ];
                              updated.splice(realIndex, 1);
                              // ensure at least one element remains
                              return {
                                ...prev,
                                preferred_locations: updated.length
                                  ? updated
                                  : [""],
                              };
                            })
                          }
                          className="remove-location-btn"
                        >
                          <ImCross />
                        </div>
                      )}
                    </div>
                  );
                })}
              {/* <InputField
              icon={<MdOutlineAccountBalanceWallet />}
              name="affiliations"
              placeholder="Affiliations"
              value={formData.affiliations}
              onChange={handleChange}
              disabled={disableEdit === ""}
            />
            <InputField
              icon={<IoMdHome />}
              name="background"
              placeholder="Background"
              value={formData.background}
              onChange={handleChange}
              disabled={disableEdit === ""}
            /> */}
              {/* <InputField
              icon={<MdOutlineInterests />}
              name="interests"
              placeholder="Interests / Hobbies"
              value={formData.interests.join(", ")}
              onChange={handleInterestsChange}
              disabled={disableEdit === ""}
            /> */}
            </div>
            <h3 className="section-title-accountInfo">Interests / Hobbies</h3>
            <div className="interests-section">
              {interestCategories.map((cat, idx) => (
                <div key={idx} className="interest-category">
                  <h4 className="interest-heading">{cat.title}</h4>

                  <div className="interest-grid">
                    {cat.options.map((option, i) => (
                      <label key={i} className="interest-item">
                        <input
                          type="checkbox"
                          checked={formData.interests.includes(option)}
                          onChange={() => handleInterestCheckbox(option)}
                          disabled={disableEdit === ""}
                        />
                        {option}
                      </label>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <div className="profile-image-athlete">
              <div className="input-section-accountInfo">
                <p className="please-select-upto-photos">
                  Please select up to 10 photos
                </p>
                <div className="input-group-accountInfo">
                  <div className="input-icon-accountInfo">
                    <FaUser />
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleImageChange}
                    disabled={disableEdit === ""}
                  />
                </div>

                {formData.images_base64?.length > 0 && (
                  <div className="preview-images">
                    {formData.images_base64.map((img, i) => (
                      <div key={i} className="image-preview-wrapper">
                        <img
                          src={`data:image/jpeg;base64,${img}`}
                          alt={`Preview ${i}`}
                          className="preview-thumbnail"
                        />
                        {disableEdit !== "" && (
                          <button
                            type="button"
                            className="remove-image-btn"
                            onClick={() => handleDeleteImage(i)}
                          >
                            <ImCross />
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <hr className="hr-bet-sec-accinfo" />
            <div className="section-title-accountInfo">Social Links</div>

            <div className="first-section-my-profile-athlete">
              {[
                { name: "facebook_url", placeholder: "Facebook URL" },
                { name: "instagram_url", placeholder: "Instagram URL" },
                { name: "tiktok_url", placeholder: "TikTok URL" },
                { name: "twitter_url", placeholder: "Twitter URL" },
                { name: "youtube_url", placeholder: "YouTube URL" },
              ].map((field) => (
                <InputField
                  key={field.name}
                  icon={<BiWorld />}
                  name={field.name}
                  placeholder={field.placeholder}
                  value={formData[field.name]}
                  onChange={handleChange}
                  disabled={disableEdit === ""}
                />
              ))}
            </div>

            <div className="ai_button_cont">
              {!formData?.athlete_profile_id ? (
                <>
                  <button
                    className="button-section-accountInfo-new"
                    onClick={addUserProfileDetails}
                  >
                    Submit
                  </button>
                  <button
                    className="edit-button-accountInfo-new"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </>
              ) : disableEdit === "edit" ? (
                <>
                  <button
                    className="button-section-accountInfo-new"
                    onClick={updateUserProfileDetails}
                  >
                    Submit
                  </button>
                  <button
                    className="edit-button-accountInfo-new"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </>
              ) : null}
            </div>
          </>
        )
      }
      {/* dsadnaskldklashdklashdlkashdl  */}
      {disableEditNormal === "edit" ? (
        <>
          {/* Primary Details */}
          <div className="section-title-accountInfo">Primary Details</div>
          <div>
            <div className="first-section-my-profile">
              {/* First Name */}
              <div className="input-section-accountInfo">
                <div className="input-group-accountInfo">
                  <div className="input-icon-accountInfo">
                    <FaUser />
                  </div>
                  <input
                    type="hidden"
                    name="user_id"
                    id="user_id"
                    value="1244003"
                  />
                  <input
                    type="text"
                    className={
                      disableEditNormal === ""
                        ? "form-control-accountInfo-disable"
                        : "form-control-accountInfo"
                    }
                    name="firstname"
                    id="firstname"
                    disabled={disableEditNormal === ""}
                    placeholder="First Name"
                    value={formDataEdit.firstname}
                    onChange={handleChangeEdit}
                  />
                </div>
              </div>

              {/* Last Name */}
              <div className="input-section-accountInfo">
                <div className="input-group-accountInfo">
                  <div className="input-icon-accountInfo">
                    <FaUser />
                  </div>
                  <input
                    type="text"
                    className={
                      disableEditNormal === ""
                        ? "form-control-accountInfo-disable"
                        : "form-control-accountInfo"
                    }
                    name="lastname"
                    id="lastname"
                    disabled={disableEditNormal === ""}
                    placeholder="Last Name"
                    value={formDataEdit.lastname}
                    onChange={handleChangeEdit}
                  />
                </div>
              </div>

              {/* Phone */}
              <div className="input-section-accountInfo">
                <div className="input-group-accountInfo">
                  <div className="input-icon-accountInfo">
                    <FaPhoneAlt />
                  </div>
                  <input
                    type="text"
                    className={
                      disableEditNormal === ""
                        ? "form-control-accountInfo-disable"
                        : "form-control-accountInfo"
                    }
                    id="phoneno"
                    name="phoneno"
                    disabled={disableEditNormal === ""}
                    placeholder="Phone Number"
                    value={formDataEdit.phoneno}
                    onChange={handleChangeEdit}
                  />
                </div>
              </div>

              {/* Company */}
              <div className="input-section-accountInfo">
                <div className="input-group-accountInfo">
                  <div className="input-icon-accountInfo">
                    <FaBuilding />
                  </div>
                  <input
                    type="text"
                    className={
                      disableEditNormal === ""
                        ? "form-control-accountInfo-disable"
                        : "form-control-accountInfo"
                    }
                    id="company_name"
                    name="company_name"
                    disabled={disableEditNormal === ""}
                    placeholder="Company Name (if applicable)"
                    value={formDataEdit.company_name}
                    onChange={handleChangeEdit}
                  />
                </div>
              </div>
            </div>

            <hr className="hr-bet-sec-accinfo" />

            {/* Address Section */}
            <div className="section-title-accountInfo">Address</div>

            {/* Address */}
            <div className="input-section-accountInfo">
              <div className="input-group-accountInfo">
                <div className="input-icon-accountInfo">
                  <IoMdHome />
                </div>
                <input
                  type="text"
                  className={
                    disableEditNormal === ""
                      ? "form-control-accountInfo-disable"
                      : "form-control-accountInfo"
                  }
                  id="address"
                  name="address"
                  disabled={disableEditNormal === ""}
                  placeholder="Address"
                  value={formDataEdit.address}
                  onChange={handleChangeEdit}
                />
              </div>
            </div>

            <div className="second-section-my-profile">
              {/* City */}
              <div className="input-section-accountInfo">
                <div className="input-group-accountInfo">
                  <div className="input-icon-accountInfo">
                    <FaCity />
                  </div>
                  <input
                    type="text"
                    className={
                      disableEditNormal === ""
                        ? "form-control-accountInfo-disable"
                        : "form-control-accountInfo"
                    }
                    id="city"
                    name="city"
                    disabled={disableEditNormal === ""}
                    placeholder="City"
                    value={formDataEdit.city}
                    onChange={handleChangeEdit}
                  />
                </div>
              </div>

              {/* State */}
              <div className="input-section-accountInfo">
                <div className="input-group-accountInfo">
                  <div className="input-icon-accountInfo">
                    <IoMdHome />
                  </div>
                  <input
                    type="text"
                    className={
                      disableEditNormal === ""
                        ? "form-control-accountInfo-disable"
                        : "form-control-accountInfo"
                    }
                    id="state"
                    name="state"
                    disabled={disableEditNormal === ""}
                    placeholder="State"
                    value={formDataEdit.state}
                    onChange={handleChangeEdit}
                  />
                </div>
              </div>

              {/* Zipcode */}
              {/* <div className="input-section-accountInfo">
                <div className="input-group-accountInfo">
                  <div className="input-icon-accountInfo">
                    <FaLocationPin />
                  </div>
                  <input
                    type="number"
                    className={
                      disableEditNormal === ""
                        ? "form-control-accountInfo-disable"
                        : "form-control-accountInfo"
                    }
                    id="zipcode"
                    name="zipcode"
                    disabled={disableEditNormal === ""}
                    placeholder="Zip Code"
                    value={formDataEdit.zipcode}
                    onChange={handleChangeEdit}
                  />
                </div>
              </div> */}

              {/* Country */}
              <div className="input-section-accountInfo">
                <div className="input-group-accountInfo">
                  <div className="input-icon-accountInfo">
                    <BiWorld />
                  </div>
                  <input
                    type="text"
                    className={
                      disableEditNormal === ""
                        ? "form-control-accountInfo-disable"
                        : "form-control-accountInfo"
                    }
                    id="country"
                    name="country"
                    disabled={disableEditNormal === ""}
                    placeholder="Country"
                    value={formDataEdit.country}
                    onChange={handleChangeEdit}
                  />
                </div>
              </div>
            </div>

            {/* Buttons */}
            <div className="ai_button_cont">
              {disableEditNormal === "add" ? (
                <>
                  <button
                    className="button-section-accountInfo-new"
                    onClick={addUserProfileDetails}
                  >
                    Add Profile
                  </button>
                  <button
                    className="edit-button-accountInfo-new"
                    onClick={() => setDisableEditNormal("")}
                  >
                    Cancel
                  </button>
                </>
              ) : disableEditNormal === "edit" ? (
                <>
                  <button
                    className="button-section-accountInfo-new"
                    onClick={updateUserProfileDetailsUser}
                  >
                    Update User
                  </button>
                  <button
                    className="edit-button-accountInfo-new"
                    onClick={() => setDisableEditNormal("")}
                  >
                    Cancel
                  </button>
                </>
              ) : null}
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

const InputField = ({ icon, name, placeholder, value, onChange, disabled }) => (
  <div className="input-section-accountInfo">
    <div className="input-group-accountInfo">
      <div className="input-icon-accountInfo">{icon}</div>
      <input
        type="text"
        className={
          disabled
            ? "form-control-accountInfo-disable"
            : "form-control-accountInfo"
        }
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  </div>
);

export default AthleteUserRole;
